<template>
  <section>
    <sys-dialog v-show="dialogVisible" :bgi="dialogBgi" :show-close="true" :error-msg="errorMsg" @close="closeDialog" />
    <sys-loading :loading="loading" />
    <div class="container" v-if="!isMobile">
      <div class="left">
        <img class="logo" src="../assets/8day-logo.png" />
        <img class="txt" src="../assets/sparker/left-txt.png" alt="" srcset="">
        <img class="bottom" src="../assets/sparker/left-bottom.png" alt="" srcset="">
        <img class="bottom01" src="../assets/sparker/left-bottom01.png" alt="" srcset="">
      </div>
      <div class="right">
        <div class="title">
          <img src="../assets/sparker/img_button 3.png" />
        </div>
        <div class="form">
          <div class="tag">
            <div class="tag-item reg" :class="isRegisterAction ? 'active' : ''" @click="tabclick(true)">
              Đăng ký
            </div>
            <div class="tag-item login" :class="!isRegisterAction ? 'active' : ''" @click="tabclick(false)">
              Đăng nhập
            </div>
          </div>
          <div class=" form-input">
            <img src="../assets/sparker/icon-user.png" />
            <input v-model="form.userName" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" onKeyUp="value=value.replace(/[\W]/g,'')" />
          </div>
          <div class="tip" v-if="rules.userName&&form.userName==''">*Tên đăng nhập đã tồn tại</div>
          <div class="tip" v-else></div>
          <div class="form-input" v-show="isRegisterAction">
            <img src="../assets/sparker/icon-phone.png" />
            <input v-model="form.phone" placeholder="Số điện thoại" maxlength="10" oninput="value=value.replace(/^\D/, '')" />
          </div>
          <div class="tip" v-if="rules.phone&&form.phone==''&&isRegisterAction">*Mật khẩu phải từ 6 đến 15
            ký
            tự</div>
          <div class="tip" v-else-if="isRegisterAction"></div>
          <div class="form-input" :style="!isRegisterAction ? { marginBottom: 0 } : ''">
            <img src="../assets/sparker/icon-password.png" />
            <input v-model="form.password" type="password" autocomplete="new-password" placeholder="Mật khẩu" maxlength="15" />
          </div>
          <div class="tip" v-if="rules.password&&form.password==''">*Số điện thoại đã tồn tại</div>
          <div class="tip" v-else></div>
          <div class="form-input" v-show="isRegisterAction">
            <img src="../assets/sparker/icon-email.png" />
            <input v-model="form.email" autocomplete="off" placeholder="Email" />
          </div>
          <div class="tip" v-if="rules.email&&form.email==''&&isRegisterAction">*Email đã tồn tại</div>
          <div class="tip" v-else-if="isRegisterAction"></div>
          <div class="form-input" v-show="isRegisterAction" style="margin-bottom: 0;position: relative;">
            <input v-model="form.verificationCode" autocomplete="off" maxlength="4" />
            <div class="codeImg">
              <span @click="getVerify" v-if="codeImg" class="validateCode">
                <img class="img" :src="codeImg" alt="code" />
              </span>
            </div>
          </div>

          <a v-if="!isRegisterAction" href="https://www.8day.com">Quên mật khẩu ?</a>
          <v-captcha ref="vcaptcha1" :dialogVisible="dialogVisible" :showCheck="showCheck" @cb="handleConfirm" :vstyle="{ top: '41px' }" :nativeButton="{
              width: '332px',
              height: '84px'
            }">
            <div v-show="isRegisterAction" class="btn btn-reg" @click="submitAction(1)" />
          </v-captcha>
          <div v-show="!isRegisterAction" class="btn" @click="submitAction(2)">
            <!-- ĐĂNG NHẬP -->
          </div>
        </div>
        <div class="cts">
          <a :href="contacts.facebook" target="_blank">
            <img src="../assets/icon-fb.png" />
          </a>
          <a :href="contacts.telegram" target="_blank">
            <img src="../assets/icon-tg.png" />
          </a>
        </div>
      </div>
    </div>
    <div class="root" v-if="isMobile">
      <img class="logo" src="../assets/8day-logo.png" />
      <img class="title" src="../assets/sparker/h502.png" style="margin-top:10px" />
      <img class="title" src="../assets/sparker/h501.png" style="width: 100%;" />
      <img class="title" src="../assets/sparker/h506.png" style="width: 100%;
    margin-top: -108px;" />
      <div class="form">
        <div class="tag">
          <div class="tag-item reg" :class="isRegisterAction ? 'active' : ''" @click="isRegisterAction = true">
            ĐĂNG KÝ
          </div>
          <div class="tag-item login" :class="!isRegisterAction ? 'active' : ''" @click="isRegisterAction = false">
            ĐĂNG NHẬP
          </div>
        </div>
        <div class="form-input">
          <img src="../assets/sparker/icon-user.png" />
          <input v-model="form.userName" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" onKeyUp="value=value.replace(/[\W]/g,'')" />
        </div>
        <div class="tip" v-if="rules.userName&&form.userName==''">*Tên đăng nhập đã tồn tại</div>
        <div class="tip" v-else></div>
        <div class="form-input" v-show="isRegisterAction">
          <img src="../assets/sparker/icon-phone.png" />
          <input v-model="form.phone" placeholder="Số điện thoại" maxlength="10" oninput="value=value.replace(/^\D/, '')" />
        </div>
        <div class="tip" v-if="rules.phone&&form.phone==''&&isRegisterAction">*Mật khẩu phải từ 6 đến 15
          ký
          tự</div>
        <div class="tip" v-else-if="isRegisterAction"></div>
        <div class="form-input" :style="!isRegisterAction ? { marginBottom: 0 } : ''">
          <img src="../assets/sparker/icon-password.png" />
          <input v-model="form.password" type="password" autocomplete="new-password" placeholder="Mật khẩu" maxlength="15" />
        </div>
        <div class="tip" v-if="rules.password&&form.password==''">*Số điện thoại đã tồn tại</div>
        <div class="tip" v-else></div>
        <div class="form-input" v-show="isRegisterAction" style="margin-bottom: 0;">
          <img src="../assets/sparker/icon-email.png" />
          <input v-model="form.email" autocomplete="off" placeholder="Email" />
        </div>
        <div class="tip" v-if="rules.email&&form.email==''&&isRegisterAction">*Email đã tồn tại</div>
        <div class="tip" v-else-if="isRegisterAction"></div>
        <div class="form-input" v-show="isRegisterAction" style="margin-bottom: 0;position: relative;">
          <input v-model="form.verificationCode" autocomplete="off" maxlength="4" />
          <div class="codeImg">
            <span @click="getVerify" v-if="codeImg" class="validateCode">
              <img class="img" :src="codeImg" alt="code" />
            </span>
          </div>
        </div>
        <a v-if="!isRegisterAction" href="https://www.8day.com">Quên mật khẩu ?</a>
        <v-captcha ref="vcaptcha2" :dialogVisible="dialogVisible" :showCheck="showCheck" @cb="handleConfirm" :vstyle="{
            width: '75%',
            top: '2vh'
          }" :nativeButton="{
            width: '100%',
            height: '8vh'
          }">
          <div v-show="isRegisterAction" class="btn btn-reg" @click="submitAction(1)">
            <!-- Đăng ký +80k -->
            <!-- <span>ĐĂNG KÝ</span> -->
            <!-- <img src="../assets/sport/icon-80k.png" /> -->
          </div>
        </v-captcha>
        <div v-show="!isRegisterAction" class="btn" @click="submitAction(2)">
          <!-- ĐĂNG NHẬP -->
        </div>
      </div>
      <img class="title" src="../assets/sparker/h505.png" style="width: 90%;margin-left:5%;margin-top:20px" />
      <a class="fixedleft" :href="contacts.facebook" target="_blank">
        <img src="../assets/icon-fb.png" />
      </a>
      <a class="fixedright" :href="contacts.telegram" target="_blank">
        <img src="../assets/icon-tg.png" />
      </a>
    </div>
  </section>
</template>

<script>
import md5 from "js-md5";
import { CONTRACTS, DOMAIN_AGENT_CODE, DOMAIN_AGENT_CODE_MAP, FORM_VALID_MESSAGE } from "../utils/constant";
import { createCustomer, userLogin, userRegister, getCode } from "../utils/request";
import { encodePlatformUrl, isMobile, validForm } from "../utils/tools";
import { captcha } from "@/mixins/captcha";

export default {
  name: "Sparker",
  mixins: [captcha],
  data() {
    return {
      isMobile: isMobile(),
      loading: false,
      isRegisterAction: true,
      dialogVisible: false,
      dialogBgi: require("../assets/sport/bgi-dialog.png"),
      contacts: CONTRACTS,
      form: {
        by: 1,
        username: "",
        verificationCode: "",
        userName: "",
        phone: "",
        password: "",
        email: "",
        link: "",
        domain: "",
        inviteCode: null
      },
      rules: {
        by: false,
        username: false,
        userName: false,
        phone: false,
        password: false,
        email: false,
        link: false,
        domain: false,
        inviteCode: false
      },
      errorMsg: {
        title: "",
        content: ""
      },
      codeImg: ''
    };
  },
  mounted() {
    window.onresize = () => {
      this.isMobile = isMobile();
    };
    this.getVerify();
  },
  methods: {
    getVerify() {
      getCode({}).then(res => {
        this.codeImg = res.body.data
      })
    },
    tabclick(bool) {
      this.rules = {
        by: false,
        username: false,
        userName: false,
        phone: false,
        password: false,
        email: false,
        link: false,
        domain: false,
        inviteCode: false
      };
      this.isRegisterAction = bool
    },
    submitAction(type) {
      let errorMsg = validForm(type, this.form);
      if (type == 1) {
        this.rules = {
          by: false,
          username: false,
          userName: false,
          phone: false,
          password: false,
          email: false,
          link: false,
          domain: false,
          inviteCode: false
        };
        let bool = true;
        ['userName', 'phone', 'password', 'email'].forEach(it => {
          console.log(this.form)
          if (!this.form[it] || this.form[it] == "") {
            this.rules[it] = true
            bool = false
          }
        });
      }

      if (Object.keys(errorMsg).length !== 0) {
        this.setDialogMsg(errorMsg.title, errorMsg.content);
        return;
      }

      // 登陆
      if (type == 2) {
        this.loading = true;
        let temp = Object.assign({}, this.form);
        let params = {
          acctType: 6,
          by: 1,
          email: temp.email,
          userName: temp.userName,
          phone: temp.phone,
          password: md5(temp.password)
        };
        this.login(params);
      } else {
        this.form.inviteCode = DOMAIN_AGENT_CODE[window.location.host] || DOMAIN_AGENT_CODE_MAP.get(location.host) || "";
        this.form.domain = window.location.host;
        this.form.username = this.form.userName;
        this.register();
      }
    },
    login(params) {
      userLogin(params)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.loggedTitle,
              FORM_VALID_MESSAGE.loggedMsg
            );
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password
              );
            }, 5000);
          } else {
            this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, res.data.msg);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, error.data);
          this.loading = false;
        });
    },
    register() {
      let params = (this.params = Object.assign({}, this.form));
      if (!/^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/.test(params.password)) {
        this.setDialogMsg(
          FORM_VALID_MESSAGE.registerFailTitle,
          FORM_VALID_MESSAGE.passwordMsg
        );
        return;
      }
      this.handleCheck(this.handleConfirm);
    },
    handleConfirm(params = this.params) {
      this.loading = true;
      params.userName = params.userName.toLowerCase();
      params.password = md5(params.password);
      params.email = this.form.email;
      params.verificationCode = this.form.verificationCode;
      userRegister(params, this.captchaParams)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerTitle,
              FORM_VALID_MESSAGE.registerMsg
            );
            createCustomer(this.form);
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password
              );
            }, 5000);
          } else {
            this.getVerify();
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerFailTitle,
              res.data.msg
            );
            this.handleOpen(res.data.code);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.registerFailTitle, error.data);
          this.loading = false;
        });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    setDialogMsg(title, msg) {
      this.errorMsg.title = title;
      this.errorMsg.content = msg;
      this.dialogVisible = true;
    }
  }
};

</script>

<style lang="less" scoped>
.container {
  //   height: 100vh;
  background-image: url("../assets/sparker/bgi-pc.jpg");
  background-size: 100% 100%;
  overflow: hidden;

  .left {
    position: relative;
    height: 100vh;
    float: left;
    margin-left: 230px;
    width: 332px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .logo {
      /* position: absolute; */
      margin-top: 50px;
      /* left: 115px; */
      z-index: 99;
      width: 80%;
    }

    .txt {
      width: 532px;
      height: 97px;
      margin-top: 40px;
      /* position: absolute;
                top: 229px; */
      /* left: 0; */
      z-index: 99;
    }

    .bottom {
      position: absolute;
      bottom: 40px;
      /* left: -169px; */
      /* width: 100%; */
      width: 800px;
    }

    .bottom01 {
      position: absolute;
      bottom: 40px;
      width: 600px;
      left: -44px;
    }
  }

  .right {
    width: 28%;
    float: right;
    margin-right: 230px;
    padding-top: 100px;
    text-align: center;

    .title {
      font-family: Montserrat, UTMErieBlack;
      font-size: 36px;
      color: #fff;

      p {
        margin: 10px;

        &:last-child {
          margin-top: 40px;
          text-indent: -5em;
          position: relative;

          img {
            width: 200px;
            position: absolute;
            top: -22px;
            right: 35px;
          }
        }
      }
    }

    .form {
      /* background-image: url("../assets/sport/bgi-form.png"); */
      /* background-size: 100% 100%; */
      position: relative;
      height: fit-content;
      width: 80%;
      margin: 130px auto 0;
      padding-bottom: 10px;
      width: 420px;
      /* height: 479px; */
      background: linear-gradient(
        180deg,
        rgba(4, 138, 128, 0.5) 48.23%,
        rgba(4, 138, 128, 0.205) 100%
      );
      border-radius: 12px;
      padding-top: 18px;
      padding-bottom: 66px;

      a {
        color: #00ffe6;
        position: relative;
        top: 20px;
      }

      .tag {
        line-height: 40px;
        margin-left: 10%;
        margin-right: 10%;
        margin-bottom: 36px;
        height: 45px;
        border-bottom: 1px solid #fff;

        .tag-item {
          width: 50%;
          float: left;
          height: 44px;
          font-family: "Inter";
          font-style: normal;
          font-weight: 700;
          font-size: 20px;
          line-height: 24px;
          color: #fff9f9;
          cursor: pointer;
        }

        .active {
          /* background-image: url("../assets/sport/bgi-tag-active.png"); */
          background-size: 100% 100%;
          color: #fff;
          border-bottom: 4px solid #fff;
        }
      }

      .tip {
        margin: auto;
        margin-bottom: 4px;
        font-family: "Inter";
        font-style: italic;
        font-weight: 400;
        font-size: 13px;
        line-height: 16px;
        /* identical to box height */
        color: #fbff39;
        text-align: left;
        width: 340px;
        height: 16px;
      }

      .form-input {
        margin: 0 auto 4px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0px 20px;
        background-size: 100% 100%;
        transition: all 0.25s ease;
        border-radius: 20px;
        width: 299px;
        height: 52px;
        background: #00ffeb;
        border-radius: 31px;
        /* background-image: url("../assets/sport/bgi-form-input.png"); */

        img {
          margin-right: 10px;
        }

        .codeImg {
          cursor: pointer;
          width: 150px;
          height: 100%;
          position: absolute;
          right: 0;
          top: 0;
          .img {
            width: 150px;
            height: 100%;
            border-radius: 0 20px 20px 0;
          }
        }

        input {
          border: none;
          outline-width: 0;
          background-color: transparent;
          height: 34px;
          width: 300px;
          font-family: UTMAvo;
          font-weight: 500;
          font-size: 22px;
          color: #131310;
          padding: 1px 2px;
        }

        input::placeholder {
          color: #131310;
          font-size: 16px;
          font-style: normal;
          font-weight: normal;
        }
      }

      .btn {
        width: 340px;
        height: 66px;
        line-height: 76px;
        margin: 0 auto;
        background-image: url("../assets/sparker/bgi-btn02.png");
        background-size: 100% 100%;
        font-size: 30px;
        font-weight: bold;
        color: #ffffff;
        cursor: pointer;
        position: relative;
        top: 31px;

        &:active {
          top: 43px;
        }

        img {
          position: relative;
          top: 7px;
        }
      }

      .btn-reg {
        background-image: url("../assets/sparker/bgi-btn01.png");
      }
    }

    .cts {
      text-align: center;
      margin-top: 40px;

      img {
        margin: 0px 30px;
      }
    }
  }
}

.root {
  background-image: url("../assets/sparker/bgi-h5.jpg");
  background-size: 100% 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  padding-bottom: 10vh;

  img.logo {
    width: 29.21vw;
    margin-top: 3vh;
  }

  img.title {
    width: 80%;
    margin-bottom: 2vh;
  }

  p {
    font-size: 2em;
    font-weight: bold;
    margin: 0;
    color: #ffffff;

    img {
      width: 40vw;
      position: relative;
      top: 18px;
      left: 10px;
    }
  }

  .form {
    /* background-image: url("../assets/sport/bgi-form.png"); */
    background-size: 100% 100%;
    position: relative;
    height: fit-content;
    width: 90%;
    margin-top: 3vh;
    border-radius: 23px;
    background: linear-gradient(
      180deg,
      rgba(4, 138, 128, 0.5) 48.23%,
      rgba(4, 138, 128, 0.205) 100%
    );
    padding-bottom: 2rem;

    a {
      color: #00ffe6;
      text-align: center;
      display: block;
    }

    .tag {
      margin-left: 2px;
      font-family: "Inter";
      font-style: normal;
      font-weight: 700;
      /* identical to box height */
      color: #fff9f9;
      margin-top: 1rem;
      padding-bottom: 1rem;
      margin-bottom: 1rem;
      height: 1rem;
      width: 80%;
      margin-left: 10%;
      border-bottom: 1px solid #fff;

      .tag-item {
        width: 50%;
        float: left;
        color: #ffffff;
        font-size: 1em;
        text-align: center;
        font-style: normal;
        font-weight: bold;
        height: 1.9rem;
      }

      .active {
        /* background-image: url("../assets/sport/bgi-tag-active.png"); */
        background-size: 100% 100%;
        /* width: 5%; */
        /* line-height: 50px; */
        position: relative;
        /* top: -20px; */
        /* font-size: 1.5em; */
        text-align: center;
        border-bottom: 2px solid #fff;
      }
    }

    .form-input {
      width: 70%;
      margin: 0 auto 0px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 5px 20px;
      background-size: 100% 100%;
      transition: all 0.25s ease;
      border-radius: 20px;
      background: #00ffeb;
      border-radius: 59px;
      /* background-image: url("../assets/sport/bgi-form-input.png"); */
      .codeImg {
        cursor: pointer;
        width: 150px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        .img {
          width: 150px;
          height: 100%;
          border-radius: 0 20px 20px 0;
        }
      }

      img {
        margin-right: 10px;
      }

      input {
        font-family: UTMAvo;
        border: none;
        outline-width: 0;
        background-color: transparent;
        height: 34px;
        width: 300px;
        font-size: 1em;
        color: #131310;
      }

      input::placeholder {
        color: #131310;
        font-size: 1em;
        font-style: normal;
        font-weight: normal;
      }
    }

    .btn {
      width: 84%;
      height: 3.6rem;
      /* line-height: 7vh; */
      text-align: center;
      margin: 0 auto;
      font-size: 1.5em;
      font-weight: bold;
      color: #ffffff;
      position: relative;
      top: 0vh;
      background-image: url("../assets/sparker/bgi-btn02.png");
      background-size: 100% 100%;

      img {
        position: relative;
        top: 4px;
        width: 20vw;
      }
    }

    .btn-reg {
      background-image: url("../assets/sparker/bgi-btn01.png");
    }

    .tip {
      margin: auto;
      /* margin-bottom: 4px; */
      font-family: "Inter";
      font-style: italic;
      font-weight: 400;
      line-height: 1.7rem;
      /* identical to box height */
      color: #fbff39;
      text-align: left;
      width: 84%;
      height: 1.7rem;
    }
  }

  .cts {
    text-align: center;
    margin-top: 2vh;

    img {
      width: 12vw;
      margin: 10px;
    }
  }

  .fixedleft,
  .fixedright {
    width: 12vw;

    img {
      width: 100%;
    }
  }

  .fixedleft {
    position: absolute;
    left: 5%;
    top: 2%;
  }

  .fixedright {
    position: absolute;
    top: 2%;
    right: 5%;
  }

  img.img-btm {
    width: 70%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sparker.vue